import React, { useEffect, useState } from "react";
import "common/css/master.css";
import { toast, ToastContainer } from "react-toastify";
import Header from "common/js/header/header";
import LoadReportTbl from "./LoadReportTbl";
import { getTchLoadSummarySvc } from "./loadReportSvc";

const LoadReportCtrl = () => {

     const [lstTchSummary, setLstTchSummary] = useState([]);
     const [loader, setLoader] = useState("none");
     const [opacity, setOpacity] = useState(1);

     
    useEffect(() => {
        getTchLoadSummary();
    }, []);

     const getTchLoadSummary = () => {
        setLoader("block");
        setOpacity(0.5);
        getTchLoadSummarySvc(handleTchLoadSummaryResponse);
    };

    const handleTchLoadSummaryResponse = (data) => {
    setLoader("none");
    setOpacity(1);
    if (data.status === 'Success') {
        console.log("the response is "+data.status);
        setLstTchSummary(data.lstTchSummary || []);
    } else {
        handleServiceError(data.message || "Failed to fetch teacher load summary");
    }
};

const handleServiceError = (svcMsg) => {
    if (svcMsg === "You are not Logged In") {
        toast.error("You are not logged in. Redirecting to login page...");
        setTimeout(() => {
            window.location.href = "/";
        }, 2000);
    } else if (svcMsg === "Server Timed Out, Login Again") {
        toast.error("Server timed out. Redirecting to login page...");
        setTimeout(() => {
            window.location.href = "/";
        }, 2000);
    } else {
        toast.error(svcMsg || "An error occurred");
    }
};



    return (
        <div>
        <Header />
        <ToastContainer autoClose={3000} hideProgressBar />
        <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12 col-centered padding-remove" style={{ marginTop: "20px" }}>
            <div className="col-sm-12 col-centered padding-remove" style={{ marginTop: "20px" }}>
                <LoadReportTbl lstTchSummary={lstTchSummary} />
            </div>
        </div>
    </div>
    );
}
export default LoadReportCtrl;